module.exports = __webpack_public_path__ + "static/media/carousel3.221df12b.jpeg";